<template>
  <v-dialog v-model="exibeModal"
            fullscreen
            hide-overlay
            persistent
            transition="dialog-bottom-transition">
    <v-card class="DashboardModalPendenciasConversaoCambial--background-color">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="confirmacaoFechamentoModal">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title><b>{{ $tc('title.campanha_dolar_conversao_cambial', 1).toUpperCase()}}</b></v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-row class="start pt-12">
          <v-col cols="3" sm="3" class="mx-3">
            <v-text-field
              v-model="idAcao"
              :label="$t('label.id_acao_campanha')"
              :disabled="loading"
              single-line
              clearable
              hide-details
              @input="onBlurFiltro"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="3" class="mx-3">
            <v-text-field
              v-model="numNotaDebito"
              :label="$t('label.numero_da_nd')"
              :disabled="loading"
              single-line
              clearable
              hide-details
              @input="onBlurFiltro"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="3" class="mx-3">
            <v-autocomplete
              class="custom-autocomplete"
              v-model="fornecedoresSelecionados"
              :label="`${$tc('label.fornecedor', 2)}`"
              :disabled="loading"
              :items="fornecedores"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="codNome"
              item-value="idExterno"
              :placeholder="$tc('message.digite_para_pesquisar', 1)"
              :clearable="true"
              chips
              multiple
              deletable-chips
              @click:append="() => triggerSelecao('planejamento-autocomplete-fornecedor')"
              @click.native="(i) => buscaAutocomplete(i, buscaFornecedores)"
              :search-input.sync="triggerFornecedor"
              @change="onBlurFiltro"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="space-between" v-show="!esperar" class="pb-2">
          <v-row align="center" class="pl-5 mb-5">
            <v-col cols="auto">
              <v-btn density="compact" @click="converterValores">{{ $tc('label.converter_valores', 1)}}</v-btn>
            </v-col>
          </v-row>
          <v-menu
            ref="data_contabilizacao_todos"
            v-if="listaAcoesApuracoes.length"
            :close-on-content-click="false"
            :nudge-right="40"
            v-model="menuAteraDataSelecionados"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-on="{ ...tooltip, ...menu }"
                    class="mr-3 mb-3"
                    id="btn_salvar"
                    color="primary"
                    :disabled="!selected.length">
                    <v-icon class="mr-2">event</v-icon>
                    {{ $t('label.definir_data') }}
                  </v-btn>
                </template>
                <span>{{ $t('message.definir_todas_data_referencia') }}</span>
              </v-tooltip>
            </template>
            <v-date-picker
              locale="pt-br"
              color="primary"
              scrollable
              v-model="dataContabilizacaoAll"
              :allowed-dates="permiteDatasCustomizadas">
              <v-spacer></v-spacer>
              <v-btn text color="primary"
                @click.native="menuAteraDataSelecionados = false">
                  {{ $t('label.cancelar') }}
              </v-btn>
              <v-btn text color="primary"
                @click.native="aplicarDataContabilizacaoAll">
                {{ $t('label.aplicar') }}
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-col
            v-if="dataContabilizacaoAll && exibirIconeJustificativaDataTodos"
            cols="auto"
            class="d-flex align-center mr-3"
          >
            <span class="mr-2">{{ retornaDataFormatada(dataContabilizacaoAll) }}</span>
            <v-btn icon small @click="abrirJustificativaParaDataTodos">
              <v-icon>receipt</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          class="tabela-pendencia_conversao_cambial"
          :headers="headers"
          :items="listaAcoesApuracoes"
          item-key="idCampanha"
          v-model="selected"
          :loading="loading"
          show-select
          @toggle-select-all="realizarSelecaoTotal"
          :options.sync="pagination"
          :server-items-length="totalPage"
          :no-data-text="$t('label.tabela_sem_conteudo')"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 30, 40, 50],
          }">
          <template v-slot:[`header.dtaReferencia`]="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on">info</v-icon>
              </template>
              <span>{{ $t('label.define_data_referencia_cotacao') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.visualizar`]="{ item }">
            <v-btn icon class="mx-0" @click.native="visualizarDetalhes(item)">
              <v-icon>visibility</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.idCampanha`]="{ item }">
            <span>{{ item.idCampanha }}</span>
          </template>
          <template v-slot:[`item.numNotaDebito`]="{ item }">
            <span>
              {{ item.numNotaDebito }}
            </span>
          </template>
          <template v-slot:[`item.fornecedor`]="{ item }">
            <span>
              {{ item.fornecedor }}
            </span>
          </template>
          <template v-slot:[`item.valorNotaDebito`]="{ item }">
            <span>{{ getMoney(item.valorNotaDebito, { tipoMoeda: 'DOLAR' }) }}</span>
          </template>
          <template v-slot:[`item.dtaInicio`]="{ item }">
            <span>
              {{ item.dtaInicio +" - "+ item.dtaFim }}
            </span>
          </template>
          <template v-slot:[`item.dtaAvaliacao`]="{ item }">
            <span>{{ retornaDataFormatada(item.dtaAvaliacao) }}</span>
          </template>
          <template v-slot:[`item.dtaReferencia`]="{ item }">
            <v-menu
              v-model="item.menuDataReferencia"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
              :disabled="!selected.some(s => s.idCampanha === item.idCampanha)"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  class="CalendarioForm-data__text"
                  :readonly="true"
                  :value="retornaDataFormatada(item.dtaReferencia)"
                  prepend-icon="event"
                  :append-icon="item.exibirIconeJustificativaData ? 'receipt' : ''"
                  @click:append.stop="editarJustificativaParaData(item)"
                />
              </template>
              <v-date-picker
                locale="pt-br"
                color="primary"
                v-model="item.dtaReferencia"
                :allowed-dates="permiteDatasCustomizadas"
                @input="item.menuDataReferencia = false"
                @change="onChangeDataReferencia(item)"
              />
            </v-menu>
          </template>
          <template v-slot:[`item.valorCotacao`]="{ item }">
            <v-text-field
              type="text"
              class="input-moeda"
              :value="item.valorCotacao === $t('message.cotacao_nao_encontrada')
                      ? item.valorCotacao
                      : item.valorCotacao ? getValorCotacaoFormatado(item.valorCotacao) : '-'"
              readonly
            />
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination
            v-model="pagination.page"
            v-if="totalPage > 1"
            :length="totalPage"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
    <convercao-nd-cotacao-justificativa
      ref="modalJustificativa"
      :tituloModal="$t('label.informe_justificativa')"
      :modoEdicao="modoEdicaoJustificativa"
      @postJustificativa="confirmarConversaoComJustificativa"
      @atualizarJustificativa="salvarJustificativaEditada"
      @cancelado="limparDataCancelada">
    </convercao-nd-cotacao-justificativa>

    <confirm
      :title="$t('title.conversao_cambial')"
      ref="confirmDialog"
      maxWidth="680"
      :message="$t('message.deseja_converter_valores')"
      :persistent="true"
      @agree="converterValoresSelecionados">
    </confirm>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { buscaAutocomplete, triggerSelecao } from '@/common/functions/autocomplete-utils';
import ApuracaoAcaoListaModalGerarNd from '@/spa/apuracao-acao/ApuracaoAcaoListaModalGerarNd';
import ModalNotaDebito from '@/spa/apuracao-acao/ModalNotaDebito';
import { pendenciasConversaoNDPaginada, buscarCotacaoMoedaDia, buscarDatasComCotacoes } from '@/common/resources/workflow-acao';
import { getMoney as formatMoney } from '@/common/functions/helpers';
import { skipLoading, forceLoading, forceHideLoading } from '@/common/functions/loading';
import Confirm from '@/shared-components/dialog/Confirm';
import ModalExibicaoMultiplasNds from '@/shared-components/ModalExibicaoMultiplasNdsCamelCase';
import moment from 'moment';
import ConvercaoNdCotacaoJustificativa from './ConvercaoNdCotacaoJustificativa';

export default {
  name: 'DashboardModalPendenciasConversaoCambial',
  components: {
    ApuracaoAcaoListaModalGerarNd,
    ModalNotaDebito,
    ConvercaoNdCotacaoJustificativa,
    Confirm,
    ModalExibicaoMultiplasNds,
  },
  data() {
    return {
      triggerFornecedor: '',
      idAcao: '',
      numNotaDebito: '',
      dataPreviaDefinida: null,
      cotacacaoPreviaDefinida: null,
      fornecedoresSelecionados: [],
      workspaceFiltrosResources: this.$api.workspaceFiltros(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      workflowAcaoAcaoResource: this.$api.workflowAcao(this.$resource),
      definicaoDataPreviaCotacaoDolar: null,
      exibeModal: false,
      buscaInicial: false,
      searchQuery: null,
      searchQueryArray: [],
      pendenciaExecutada: false,
      abrirModalND: false,
      pagination: {
        itemsPerPage: 20,
        page: 1,
      },
      listaAcoesApuracoes: [],
      fornecedores: [],
      totalPage: 0,
      timeout: 0,
      esperar: false,
      selected: [],
      rules: {
        required: (value) => (!!value || value === 0) || this.$t('message.campo_obrigatorio'),
      },
      headers: [
        {
          text: '',
          value: 'visualizar',
          sortable: false,
          width: '48px',
        },
        {
          text: this.$tc('label.id_acao_campanha', 1),
          value: 'idCampanha',
          sortable: false,
          width: '10%',
        },
        {
          text: this.$tc('label.numero_da_nd', 1),
          value: 'numNotaDebito',
          sortable: true,
        },
        {
          text: this.$tc('label.fornecedor', 1),
          value: 'fornecedor',
          sortable: true,
        },
        {
          text: this.$tc('label.valor_nd', 1),
          value: 'valorNotaDebito',
          sortable: false,
        },
        {
          text: this.$tc('label.periodo_vigencia', 1),
          value: 'dtaInicio',
          sortable: true,
        },
        {
          text: this.$tc('label.data_aprovacao', 1),
          value: 'dtaAvaliacao',
          sortable: true,
        },
        {
          text: this.$tc('label.data_referencia', 1),
          value: 'dtaReferencia',
          sortable: false,
        },
        {
          text: this.$tc('label.valor_cotacao', 1),
          value: 'valorCotacao',
          sortable: false,
        },
      ],
      tituloModal: '',
      justificativaTipoUso: '',
      listaPendenciasConversaoCambialLocal: [],
      justificativa: '',
      justificativaSomenteLeitura: false,
      isAprovacao: false,
      acaoModal: null,
      loading: false,
      idApuracaoSelecionada: 0,
      executarAnaliseSelecionada: false,
      workspace: {},
      menuAteraDataSelecionados: false,
      dataContabilizacaoAll: null,
      exibirIconeJustificativaDataTodos: false,
      datasPermitidas: [],
      mapaMoedas: {
        DOLAR: 'USD',
        DOLLAR: 'USD',
        DÓLAR: 'USD',
        REAL: 'BRL',
        EURO: 'EUR',
      },
      itemEmEdicao: null,
      modoEdicaoJustificativa: false,
    };
  },
  props: {
    value: Object,
    listaPendenciasConversaoCambial: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    listaPendenciasConversaoCambialAtual() {
      return (this.listaPendenciasConversaoCambial && this.listaPendenciasConversaoCambial.length)
        ? this.listaPendenciasConversaoCambial
        : this.listaPendenciasConversaoCambialLocal;
    },
  },
  methods: {
    ...mapGetters,
    buscaAutocomplete,
    triggerSelecao,
    onBlurFiltro() {
      this.triggerFiltroBusca();
    },
    verificaDefinicaoDataPreviaCotacaoDolar() {
      this.configSistemaResource.buscarChave({ chave: 'DEFINIR_DATA_PREVIA_COTACAO_DOLAR' })
        .then((resp) => {
          this.definicaoDataPreviaCotacaoDolar = resp.body;
        });
    },
    setaDataPreviaFormatada() {
      this.dataPreviaDefinida = this.definicaoDataPreviaCotacaoDolar ? this.retornaDataFormatada('2026-02-10') : null;
      this.cotacacaoPreviaDefinida = this.dataPreviaDefinida ? formatMoney(4.45, 0.0, 2, this.getSimboloMoeda()) : null;
    },
    triggerFiltroBusca() {
      if (this.exibeModal) {
        this.pagination.page = 1;
        if (this.timeout) {
          window.clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(() => {
          this.filtrar();
        }, 300);
      }
    },
    getMoney(valor, item = null, decimalPlaces = 2) {
      return formatMoney(valor, 0.0, decimalPlaces, this.getSimboloMoeda(item));
    },
    getValorCotacaoFormatado(valorCotacao) {
      const valorNumerico = Number(valorCotacao);
      if (Number.isNaN(valorNumerico)) {
        return '-';
      }

      const valorFormatado = valorNumerico.toLocaleString('pt-BR', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });

      return `R$ ${valorFormatado}`;
    },
    getSimboloMoeda(item = null) {
      const tipoMoeda = (this.getTipoMoeda(item) || '').toUpperCase();
      if (tipoMoeda === 'DOLAR' || tipoMoeda === 'DOLLAR' || tipoMoeda === 'USD') {
        return 'US$';
      }
      return 'R$';
    },
    getTipoMoeda(item = null) {
      if (item) {
        return item.tipoMoeda || item.tipo_moeda || item.moeda || item.tipo_moeda_acao || null;
      }

      if (this.selected && this.selected.length) {
        const itemSelecionado = this.selected[0];
        return itemSelecionado.tipoMoeda
          || itemSelecionado.tipo_moeda
          || itemSelecionado.moeda
          || itemSelecionado.tipo_moeda_acao
          || null;
      }

      if (this.listaAcoesApuracoes && this.listaAcoesApuracoes.length) {
        const primeiroItem = this.listaAcoesApuracoes[0];
        return primeiroItem.tipoMoeda
          || primeiroItem.tipo_moeda
          || primeiroItem.moeda
          || primeiroItem.tipo_moeda_acao
          || null;
      }

      return 'REAL';
    },
    retornaDataFormatada(data) {
      if (!data) return null;
      return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    visualizarDetalhes(acao) {
      let routeName = 'detalharAcao';
      if (this.isTemplateVerbaVariavel(acao)) {
        routeName = 'detalharAcaoVerbaVariavel';
      }
      const route = this.$router.resolve({ name: routeName, params: { idAcao: acao.idCampanha, from: 'dashboard-inicial', modalDashboard: 'PENDENCIAS_NDS' } });
      this.abreNovaAbaPlanejamento(acao.id, route);
    },
    abreNovaAbaPlanejamento(idAcao, route) {
      const newTab = window.open(route.href, '_blank');
      if (newTab) {
        localStorage.setItem('idAcao', idAcao);
      }
    },
    abrirModalJustificativa(item, isNovoValor = false) {
      this.notaDebito = item;
      setTimeout(() => this.$refs.modalJustificativa.open(isNovoValor), 2E2);
    },
    open() {
      this.buscaInicial = true;
      this.carregarWorkspaceFiltros();
      Promise.all([
        this.carregarFiltros(),
      ]).then(() => {
        this.exibeModal = true;
      });
    },
    realizarSelecaoTotal(toggleSelectAll) {
      if (toggleSelectAll.value) {
        this.selected = [];
        this.selected = [...this.listaAcoesApuracoes];
      } else {
        this.selected = [];
      }
    },
    buscaFornecedores(autocomplete) {
      const parametros = {
        autocomplete,
        pagador: false,
        indAtivo: true,
      };
      this.planejamentoAcaoResource.buscarFornecedores(parametros)
        .then((res) => {
          this.fornecedores = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarFiltros() {
      Promise.all([
        this.buscaFornecedores(null),
      ]).then(() => {
      });
    },
    close() {
      this.exibeModal = false;
      this.resetaModal();
      if (this.pendenciaExecutada) {
        this.$emit('DashboardModalPendenciasConversaoCambial__fechar', true);
      } else {
        this.$emit('DashboardModalPendenciasConversaoCambial__fechar', false);
      }
    },
    resetaModal() {
      this.searchQuery = null;
      this.pagination.page = 1;
      this.pagination.itemsPerPage = 20;
    },
    filtrar() {
      if (!this.buscaInicial) {
        this.listaPendenciasConversaoCambialLocal = [];
        setTimeout(() => {
          this.buscaPendencias();
        }, 1000);
      }
    },
    buscarCotacaoMoedaIndividual(item) {
      if (!item.dtaReferencia) {
        this.$set(item, 'valorCotacao', null);
        return;
      }

      const termoMoeda = (this.getTipoMoeda(item) || '').toUpperCase();

      const params = {
        data: item.dtaReferencia,
        moeda: this.mapaMoedas[termoMoeda] || termoMoeda,
      };

      buscarCotacaoMoedaDia(params, this.$resource)
        .then((res) => {
          const cotacao = res.data && res.data.cotacao_compra ? res.data.cotacao_compra : null;
          if (cotacao) {
            this.$set(item, 'valorCotacao', cotacao);
          } else {
            this.$set(item, 'valorCotacao', this.$t('message.cotacao_nao_encontrada'));
            this.$toast(this.$t('message.cotacao_nao_encontrada'));
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
          this.$set(item, 'valorCotacao', this.$t('message.cotacao_nao_encontrada'));
        });
    },
    buscarDatasCotacoes() {
      buscarDatasComCotacoes({}, this.$resource)
        .then((res) => {
          this.datasPermitidas = res.data.map((item) => item.data_cotacao);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    permiteDatasCustomizadas(val) {
      const hoje = moment().format('YYYY-MM-DD');
      const possuiCotacao = this.datasPermitidas.includes(val);
      const naoEFutura = val <= hoje;

      return possuiCotacao && naoEFutura;
    },
    async converterValores() {
      if (this.selected.length === 0) {
        this.$toast(this.$t('message.selecione_linha_para_conversao_nd'));
        return;
      }

      const invalidos = this.selected.filter((item) => !item.dtaReferencia || !item.valorCotacao || item.valorCotacao === this.$t('message.cotacao_nao_encontrada') || item.valorCotacao === '-');

      if (invalidos.length > 0) {
        this.$toast(this.$t('message.preencha_data_referencia_cotacao'));
        return;
      }

      this.$refs.confirmDialog.open();
    },
    converterValoresSelecionados() {
      this.loading = true;
      const payload = {
        acoes: this.selected.map((item) => ({
          idCampanha: item.idCampanha,
          numNotaDebito: item.numNotaDebito,
          valorNotaDebito: item.valorNotaDebito,
          dataReferencia: item.dtaReferencia,
          valorCotacao: item.valorCotacao,
          justificativa: item.justificativa,
        })),
      };

      forceLoading();
      this.workflowAcaoAcaoResource.converterValoresNd(null, payload)
        .then(() => {
          this.$toast(this.$t('message.valores_convertidos_sucesso'));
          this.selected = [];
          forceHideLoading();
          this.buscaPendencias(true);
        })
        .catch((err) => {
          this.$toast(err.data ? err.data.error : 'Erro ao converter');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    aplicarDataContabilizacaoAll() {
      if (this.dataContabilizacaoAll) {
        this.modoEdicaoJustificativa = false;
        this.menuAteraDataSelecionados = false;
        this.itemEmEdicao = 'MULTIPLO';
        this.$refs.modalJustificativa.open();
      }
    },
    abrirJustificativaParaDataTodos() {
      if (!this.dataContabilizacaoAll) {
        return;
      }

      this.modoEdicaoJustificativa = true;
      this.itemEmEdicao = 'MULTIPLO';
      this.$refs.modalJustificativa.open('');
    },
    onChangeDataReferencia(item) {
      this.$set(item, 'exibirIconeJustificativaData', false);
      this.modoEdicaoJustificativa = false;
      this.itemEmEdicao = item;
      this.$refs.modalJustificativa.open();
    },
    abrirJustificativaParaData(item) {
      this.modoEdicaoJustificativa = false;
      this.itemEmEdicao = item;
      this.$refs.modalJustificativa.open();
    },
    editarJustificativaParaData(item) {
      this.modoEdicaoJustificativa = true;
      this.itemEmEdicao = item;
      this.$refs.modalJustificativa.open(item.justificativa || '');
    },
    confirmarConversaoComJustificativa(justificativaDigitada) {
      if (this.itemEmEdicao === 'MULTIPLO') {
        this.selected.forEach((item) => {
          item.dtaReferencia = this.dataContabilizacaoAll;
          item.justificativa = justificativaDigitada;
          item.exibirIconeJustificativaData = true;
          this.buscarCotacaoMoedaIndividual(item);
        });
        this.exibirIconeJustificativaDataTodos = true;
        this.menuAteraDataSelecionados = false;
      } else if (this.itemEmEdicao) {
        this.itemEmEdicao.justificativa = justificativaDigitada;
        this.itemEmEdicao.exibirIconeJustificativaData = true;
        this.buscarCotacaoMoedaIndividual(this.itemEmEdicao);
      }

      this.itemEmEdicao = null;
      this.justificativa = '';
    },
    salvarJustificativaEditada(justificativaDigitada) {
      if (this.itemEmEdicao === 'MULTIPLO') {
        this.selected.forEach((item) => {
          item.justificativa = justificativaDigitada;
        });
      } else if (this.itemEmEdicao) {
        this.itemEmEdicao.justificativa = justificativaDigitada;
      }

      this.itemEmEdicao = null;
    },
    limparDataCancelada() {
      if (this.itemEmEdicao === 'MULTIPLO') {
        this.dataContabilizacaoAll = null;
        this.exibirIconeJustificativaDataTodos = false;
        this.menuAteraDataSelecionados = false;
      } else if (this.itemEmEdicao) {
        this.itemEmEdicao.dtaReferencia = null;
        this.itemEmEdicao.valorCotacao = null;
        this.itemEmEdicao.exibirIconeJustificativaData = false;
      }
      this.itemEmEdicao = null;
    },
    buscaPendencias(zeraPaginacao = false) {
      if (zeraPaginacao) {
        this.pagination.page = 1;
        this.selected = [];
      }
      const params = {
        asc: this.pagination.sortDesc ? !this.pagination.sortDesc[0] : true,
        colunaOrdenacao: this.pagination.sortBy ? this.pagination.sortBy[0] : 'dta_solicitacao',
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        id_perfil: this.usuarioLogado.idPerfil,
      };
      if (this.idAcao) {
        params.id_acao = this.idAcao;
      }
      if (this.numNotaDebito) {
        params.num_nota_debito = this.numNotaDebito;
      }
      if (this.fornecedoresSelecionados && this.fornecedoresSelecionados.length) {
        params.fornecedores = this.fornecedoresSelecionados.map((f) => parseInt(f.id || f, 10));
      }
      this.organizarColunasOrdenacao(params);

      this.listaAcoesApuracoes = [];
      this.loading = true;
      pendenciasConversaoNDPaginada(params, this.$resource)
        .then((response) => {
          this.buscaInicial = false;
          this.totalPage = Math.ceil(response.data.quantidadeRegistrosPagina / this.pagination.itemsPerPage);
          const itens = response.data.resposta.map((item) => ({
            ...item,
            status: item.status,
            dtaReferencia: item.dtaReferencia || this.dataPreviaDefinida,
            menuDataReferencia: false,
            exibirIconeJustificativaData: false,
          }));
          this.listaAcoesApuracoes = [...itens];
          this.calcularTotaisRecebimento();
          const acaoDataContabilizacao = this.listaAcoesApuracoes.filter((dados) => dados.informaDataContabilizacao === true);
          if (acaoDataContabilizacao.length > 0) {
            this.showDataContabilizacaoAll = true;
          }
          this.searchQueryArray = [];
          this.escondePaginacao = (this.totalPage / this.pagination.itemsPerPage) <= 1;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.data) {
            this.$toast(err.data.error);
          }
        });
    },
    carregarWorkspaceFiltros() {
      const entidade = 'pendencia_conversao_nd';
      this.workspaceFiltrosResources.pesquisar({ entidade })
        .then((response) => {
          this.workspace = response.data || {};
          if (Object.keys(this.workspace).length) {
            this.searchQuery = this.workspace.filtros.searchQuery;
          }
          this.buscaPendencias(false);
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    salvarFiltrosWorkspace(filtro) {
      this.workspace.filtros = filtro;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
    atualizarWorkspace() {
      skipLoading();
      const entidade = 'pendencia_conversao_nd';
      this.workspaceFiltrosResources.atualizar({ entidade }, this.workspace)
        .then()
        .catch((err) => {
          this.$error(this, err);
        });
    },
    inserirWorkspace() {
      skipLoading();
      const entidade = 'pendencia_conversao_nd';
      this.workspaceFiltrosResources.inserir({ entidade }, this.workspace)
        .then((response) => {
          this.workspace.id = response.data;
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    confirmacaoFechamentoModal() {
      this.close();
    },
    fecharModalND() {
      this.abrirModalND = false;
      this.idApuracaoSelecionada = 0;
      this.executarAnaliseSelecionada = false;
      setTimeout(() => { this.acaoModal = null; }, 2E2);
    },
    closeModalJustificativa() {
      this.dialogJustificativaTipoUso = false;
    },
    isTemplateVerbaVariavel(acao) {
      const { template } = acao;
      return template === 'VERBA_VARIAVEL';
    },
    organizarColunasOrdenacao(params) {
      if (params.colunaOrdenacao === 'idAcao') {
        params.colunaOrdenacao = 'id_acao';
      }
      if (params.colunaOrdenacao === 'numNotaDebito') {
        params.colunaOrdenacao = 'num_nota_debito';
      }
      if (params.colunaOrdenacao === 'fornecedor') {
        params.colunaOrdenacao = 'id_fornecedor';
      }
      if (params.colunaOrdenacao === 'dtaInicio') {
        params.colunaOrdenacao = 'dta_inicio';
      }
      if (params.colunaOrdenacao === 'dtaAvaliacao') {
        params.colunaOrdenacao = 'dta_avaliacao';
      }
    },
  },
  watch: {
    'pagination.sortBy': function watchSortBy() {
      this.buscaPendencias();
    },
    'pagination.sortDesc': function watchSortDesc() {
      this.buscaPendencias();
    },
    'pagination.page': function watchPage() {
      this.buscaPendencias();
    },
    'pagination.itemsPerPage': function watchItemsPerPage() {
      this.buscaPendencias();
    },
  },
  mounted() {
    this.open();
    this.verificaDefinicaoDataPreviaCotacaoDolar();
    this.setaDataPreviaFormatada();
    this.buscarDatasCotacoes();
  },
};
</script>
<style lang="scss">
.DashboardModalPendenciasConversaoCambial--background-color {
  background-color: #EEEEEE !important;
}
</style>
